import { Heading, Stack, Text, Flex, Grid } from "@chakra-ui/react";
import { setQuestionAnswer } from "app/features/question/questionSlice";
import { useAppDispatch } from "app/hook";
import { Formik, Form } from "formik";
import { FC, useEffect, useState } from "react";
import PrevAndNextButton from "./PrevAndNextButton";

interface MCQSQuestionProps {
  question: IAnsweredMCQSQuestion;
  prevQuestionHandler: () => void;
  nextQuestionHandler: () => void;
  index: number;
  isLastQuestion: boolean;
  setIsLastQuestion: React.Dispatch<React.SetStateAction<boolean>>;
}
const MCQSQuestion: FC<MCQSQuestionProps> = ({
  question,
  prevQuestionHandler,
  nextQuestionHandler,
  index,
  isLastQuestion,
  setIsLastQuestion,
}) => {
  const [mcqSAnswer, setMcqSAnswer] = useState<number | undefined>(
    question?.mcqsSubmittedAnswer
  );

  useEffect(() => {
    setMcqSAnswer(question?.mcqsSubmittedAnswer);
  }, [question]);
  const dispatch = useAppDispatch();
  return (
    <>
      <Heading fontSize="md" fontWeight="semibold">
        Choose one correct option
      </Heading>
      <Formik
        enableReinitialize
        initialValues={{
          mcqSOptions: question?.mcqSOptions ?? [],
          isPrev: false,
        }}
        onSubmit={(values) => {
          if (mcqSAnswer === question.mcqSAnswer) {
            dispatch(
              setQuestionAnswer({
                index,
                mcqsSubmittedAnswer: mcqSAnswer,
                isCorrect: true,
                marks: question.positiveMarks,
                attempted: true,
              })
            );
          } else if (mcqSAnswer === undefined) {
            dispatch(
              setQuestionAnswer({
                index,
                attempted: false,
              })
            );
          } else {
            dispatch(
              setQuestionAnswer({
                index,
                mcqsSubmittedAnswer: mcqSAnswer,
                isCorrect: false,
                marks: question.negativeMarks,
                attempted: true,
              })
            );
          }
          values.isPrev ? prevQuestionHandler() : nextQuestionHandler();
          if (isLastQuestion) {
            setIsLastQuestion(true);
          }
        }}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Stack>
              {values.mcqSOptions.map((option, index) => (
                <Flex
                  key={index}
                  name={`mcqSOptions.${index}`}
                  align="center"
                  onClick={() => setMcqSAnswer(index)}
                >
                  <Grid
                    placeItems="center"
                    boxSize={"50px"}
                    borderRadius="xl"
                    flexShrink="0"
                    bg={mcqSAnswer === index ? "teal.400" : "gray.200"}
                    color={mcqSAnswer === index ? "white" : "black"}
                  >
                    {String.fromCharCode(65 + index)}
                  </Grid>{" "}
                  <Text ml="4">{option}</Text>
                </Flex>
              ))}
            </Stack>

            <PrevAndNextButton setFieldValue={setFieldValue} />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default MCQSQuestion;
